import { makeStyles, createStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(() => createStyles({
    paper: {
        height: "100%",
    },
}));

export default useStyles;
